var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticClass:"galaxy-num-input",attrs:{"size":_vm.size,"clearable":_vm.clearable,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"change":_vm.changeInput,"blur":_vm.onBlur,"focus":_vm.focus},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }